import React from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {Box, Button, Typography} from "@mui/material";


import TransMsg from "../../transMessage";
import VendorStaticData from "../../../../assets/data/vendorList";
import {CardProps, vendorCardStyles} from "./vendorCard-helpers";


export const VendorCard = (props: CardProps) => {
    const {item, logoImage, index, onSelectVendorItem} = props;
    const {t} = useTranslation();
    const navigate = useNavigate();

    const onSelectMore = (itemData: any) => {
        // @ts-ignore
        amplitude.logEvent(`user clicked learn more for ${itemData?.title} vendor`)
        const vendorItemIndex = VendorStaticData?.data.findIndex((item: any) => item?.vendorName === itemData?.title)
        navigate(`/vendor-details?routePath=${itemData?.title}&vendor=${itemData?.name}&index=${vendorItemIndex}`)
    }

    return (
        <Box sx={vendorCardStyles.container}>
            <Box component="img" src={logoImage} alt={`vendor-item-${index}`} sx={vendorCardStyles.imagePanel}/>

            <Box sx={vendorCardStyles.contentPanel}>
                <Typography
                    sx={vendorCardStyles.cardTitle}>
                    {item?.title}
                </Typography>

                <Typography sx={vendorCardStyles.cardDescription}>
                    {item?.card_description}
                </Typography>

                <Box sx={vendorCardStyles.cardActionPanel}>
                    <Button
                        variant='outlined'
                        onClick={() => onSelectVendorItem(item)}
                        sx={{...vendorCardStyles.cardButton}}>
                        <Typography
                            sx={{...vendorCardStyles.cardButtonText, color: "#404144"}}>
                            {t(TransMsg.LAUNCH_TOOL_LABEL)}
                        </Typography>
                    </Button>
                    <Button
                        variant='contained'
                        onClick={() => onSelectMore(item)}
                        sx={{...vendorCardStyles.cardButton, borderColor: 'transparent'}}>

                        <Typography
                            sx={{...vendorCardStyles.cardButtonText, color: "#fff"}}>
                            {t(TransMsg.LEARN_MORE_LABEL)}
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

